import jQuery from "jquery";
import Cookies from "js-cookie";

// eslint-disable-next-line no-unused-vars, no-undef
const $ = jQuery;

// eslint-disable-next-line no-shadow, func-names
(($) => {
    // Check to see if the customer has previously hidden the announcement bar
    // and if so, don't render it!
    // eslint-disable-next-line no-undef
    if (Cookies.get("announcementbar") !== "hidden") {
        $(".announcement-bar").removeClass("inactive");
    }

    // If the customer clicks on the close icon, remove the announcement bar
    // and set a cookie so the bar doesn't appear for 7 days
    $(document).on("click", ".announcement-bar .bannerClose", () => {
        $(".announcement-bar").addClass("inactive");
        // eslint-disable-next-line no-undef
        Cookies.set("announcementbar", "hidden", { expires: 7 });
    });
    // eslint-disable-next-line no-undef
})(jQuery);
